import React, { useEffect } from 'react'; // <--- Añade useEffect

const DatosxUsuario = ({
  nombres,
  apellidopat,
  apellidomat,
  documento,
  selectedFuncion,
  funciones,
  setSelectedFuncion
}) => {

  useEffect(() => {
    if (funciones.length > 0) {
      const funcionPorDefecto = funciones[0].per_CH_nomParam;
      setSelectedFuncion(funcionPorDefecto);
    }
  }, [funciones, setSelectedFuncion]);

  return (
    <div className="w-100">
      {/* Sección de Nombres */}
      <div className="mb-3">
        <label className="form-label fw-bold">Nombres y Apellidos</label>
        <input
          type="text"
          value={`${nombres} ${apellidopat} ${apellidomat}`}
          className="form-control"
          style={{
            border: "1px solid rgb(53, 53, 166)",
            fontSize: "15px",
            padding: "8px",
            borderRadius: "2px",
            textAlign: "center"
          }}
          disabled
        />
      </div>

      {/* Sección de Documento */}
      <div className="mb-3">
        <label className="form-label fw-bold">Documento de Identidad</label>
        <input
          type="text"
          value={documento}
          className="form-control"
          style={{
            border: "1px solid rgb(53, 53, 166)",
            fontSize: "15px",
            padding: "8px",
            borderRadius: "2px",
            textAlign: "center"
          }}
          disabled
        />
      </div>

      {/* Sección de Función */}
      <div className="mb-3">
        <label className="form-label fw-bold">Función Asignada</label>
        <input
          type="text"
          value={selectedFuncion || "Cargando..."}
          className="form-control"
          style={{
            border: "1px solid rgb(53, 53, 166)",
            fontSize: "15px",
            padding: "8px",
            borderRadius: "2px",
            textAlign: "center"
          }}
          disabled
        />
      </div>
    </div>
  );
};

export default DatosxUsuario;